import { get } from 'lodash';

import GlobalConstants from '@/online-merchant-onboarding/utils/globalConstant';

import {
	SUPER_CATEGORY_LIST_SUCCESS,
	SUPER_CATEGORY_LIST_ERROR,
	CATEGORY_LIST_ERROR,
	CATEGORY_LIST_SUCCESS,
	SUB_CATEGORY_LIST_SUCCESS,
	SUB_CATEGORY_LIST_ERROR,
	PINCODE_DETAILS_ERROR,
	PINCODE_DETAILS_REQUESTING,
	PINCODE_DETAILS_SUCCESS,
	UPDATE_MERCHANT_DETAILS,
	UPDATE_MERCHANT_DETAILS_ERROR,
	UPDATE_MERCHANT_DETAILS_SUCCESS,
	KYC_STATUS_REQUESTED,
	KYC_STATUS_SUCCESS,
	KYC_STATUS_ERROR,
	SUPER_CATEGORY_LIST_REQUESTING,
	CATEGORY_LIST_REQUESTING,
	SUB_CATEGORY_LIST_REQUESTING,
	RESET_KYC_PAGE_DATA,
} from './types';

export const initialState = {
	loading: false,
	superCategoryList: [],
	categoryList: [],
	subCategoryList: [],
	pincodeDetails: '',
	pincodeInvalid: false,
	businessDetailsCompleted: false,
	businessDetailsFraudDetected: false,
	kycStatusLoading: false,
	kycStatus: {
		[GlobalConstants.KYC_STEPS.BUSINESS_DETAILS]: {
			sectionName: 'Business Details',
			status: GlobalConstants.KYC_STATUS.PENDING,
			activeImage: 'businessDetails',
			inactiveImage: 'businessDetailsInactive',
		},
		[GlobalConstants.KYC_STEPS.BANK_SECTION]: {
			sectionName: 'Bank Account',
			status: GlobalConstants.KYC_STATUS.PENDING,
			activeImage: 'bankAccount',
			inactiveImage: 'bankAccountInactive',
		},
		[GlobalConstants.KYC_STEPS.GST_PAN_SECTION]: {
			sectionName: 'GST/PAN Details',
			status: GlobalConstants.KYC_STATUS.PENDING,
			activeImage: 'gstPan',
			inactiveImage: 'gstPanInactive',
		},
		[GlobalConstants.KYC_STEPS.GST_PAN_DOCUMENT_UPLOAD_SECTION]: {
			sectionName: 'Documents',
			status: GlobalConstants.KYC_STATUS.PENDING,
			activeImage: 'documents',
			inactiveImage: 'documentsInactive',
		},
	},
	kycCompleted: false,
};

const getKycUpdatedStatus = (oldStatus, newStatus, stepKey) => ({
	[stepKey]: {
		...oldStatus[stepKey],
		status: newStatus[stepKey].status,
	},
});

function kyc(state = initialState, action) {
	switch (action.type) {
		case SUPER_CATEGORY_LIST_REQUESTING: {
			return {
				...state,
				superCategoryList: [],
				categoryList: [],
				subCategoryList: [],
			};
		}
		case SUPER_CATEGORY_LIST_SUCCESS: {
			const categories = get(action, 'data.data', [])
				// .filter(category => category.mcc)
				.map((category) => ({
					code: category.categoryNodeId,
					displayCodeName: category.value,
				}));
			return { ...state, superCategoryList: categories };
		}
		case SUPER_CATEGORY_LIST_ERROR:
			return { ...state, superCategoryList: [] };

		case CATEGORY_LIST_REQUESTING: {
			return { ...state, categoryList: [], subCategoryList: [] };
		}
		case CATEGORY_LIST_SUCCESS: {
			const categories = get(action, 'data.data.children', [])
				// .filter(category => category.mcc)
				.map((category) => ({
					code: category.categoryNodeId,
					displayCodeName: category.value,
				}));
			return { ...state, categoryList: categories };
		}
		case CATEGORY_LIST_ERROR:
			return { ...state, categoryList: [] };

		case SUB_CATEGORY_LIST_REQUESTING: {
			return { ...state };
		}
		case SUB_CATEGORY_LIST_SUCCESS: {
			const categories = get(action, 'data.data.children', []).map(
				(category) => ({
					code: category.categoryNodeId,
					displayCodeName: category.value,
				}),
			);
			return { ...state, subCategoryList: categories };
		}
		case SUB_CATEGORY_LIST_ERROR:
			return { ...state, subCategoryList: [] };

		case PINCODE_DETAILS_REQUESTING:
			return { ...state, pincodeDetails: '', pincodeInvalid: false };
		case PINCODE_DETAILS_SUCCESS: {
			let cityState = '';
			if (
				get(action, 'data.data.city', '') &&
				get(action, 'data.data.state', '')
			) {
				cityState = `${get(action, 'data.data.city', '')}, ${get(
					action,
					'data.data.state',
					'',
				)}`;
			}
			return { ...state, pincodeDetails: cityState, pincodeInvalid: false };
		}
		case PINCODE_DETAILS_ERROR:
			return { ...state, pincodeDetails: '', pincodeInvalid: true };
		case UPDATE_MERCHANT_DETAILS:
			return { ...state, loading: true };
		case UPDATE_MERCHANT_DETAILS_SUCCESS:
			return {
				...state,
				loading: false,
				businessDetailsCompleted: true,
				pincodeDetails: '',
				businessDetailsFraudDetected: false,
			};
		case UPDATE_MERCHANT_DETAILS_ERROR: {
			const businessDetailsFraudDetected =
				get(action, 'error.code', '') === GlobalConstants.FRAUD_DETECTED;
			return { ...state, loading: false, businessDetailsFraudDetected };
		}
		case KYC_STATUS_REQUESTED:
			return { ...state, kycStatusLoading: true };
		case KYC_STATUS_SUCCESS: {
			let businessDetailsCompleted = false;
			const { kycStatusData, kycCompleted } = action.data;
			if (
				kycStatusData[GlobalConstants.KYC_STEPS.BUSINESS_DETAILS].status ===
				GlobalConstants.KYC_STATUS.COMPLETED
			) {
				businessDetailsCompleted = true;
			}
			return {
				...state,
				kycStatusLoading: false,
				businessDetailsCompleted,
				kycStatus: {
					...getKycUpdatedStatus(
						state.kycStatus,
						kycStatusData,
						GlobalConstants.KYC_STEPS.BUSINESS_DETAILS,
					),
					...getKycUpdatedStatus(
						state.kycStatus,
						kycStatusData,
						GlobalConstants.KYC_STEPS.BANK_SECTION,
					),
					...getKycUpdatedStatus(
						state.kycStatus,
						kycStatusData,
						GlobalConstants.KYC_STEPS.GST_PAN_SECTION,
					),
					...getKycUpdatedStatus(
						state.kycStatus,
						kycStatusData,
						GlobalConstants.KYC_STEPS.GST_PAN_DOCUMENT_UPLOAD_SECTION,
					),
				},
				kycCompleted,
			};
		}
		case KYC_STATUS_ERROR:
			return { ...state, kycStatusLoading: false };
		case RESET_KYC_PAGE_DATA:
			return {
				...state,
				kycStatusLoading: false,
				superCategoryList: [],
				categoryList: [],
				subCategoryList: [],
				pincodeDetails: '',
				pincodeInvalid: false,
				businessDetailsFraudDetected: false,
			};
		default:
			return state;
	}
}

export default kyc;
